import menuAim from './menu-aim';

import { MOBILE } from '../../assets/scripts/constants';
import PageScroll from '../../assets/scripts/helpers/Scroll';
import Tabs from '../../components/tabs/tabs';

const HTML_CLASSLIST = document.documentElement.classList;

class Menu {
	constructor() {
		this.init();
	}

	init() {
		this.container = document.querySelector('[data-menu]');

		if (!this.container) return;

		this._initMenu();
	}

	_initMenu() {
		this.openers = Array.from(document.querySelectorAll('[data-menu-opener]'));
		this.searchForm = this.container.querySelector('.menu__search-form');
		this.loader = this.container.querySelector('.search__loader');
		this.empty = this.container.querySelector('.search__empty-wrapper');
		this.isOpened = false;

		this.openers.forEach((opener) => {
			opener.addEventListener('click', (evt) => {
				evt.preventDefault();

				this.toggle();
			});
		});

		this.onWindowClick = (evt) => {
			const mm = window.matchMedia(MOBILE);
			const isOpener = this.openers.some((opener) => opener.contains(evt.target));
			const isSearchOpener = evt.target.hasAttribute('data-search-opener');

			if (this.container.contains(evt.target) || isOpener || (mm.matches && isSearchOpener)) {
				return;
			}

			this.close();
		};
		this.onWindowKeydown = (evt) => {
			if (evt.key === 'Escape') {
				this.close();
			}
		};

		this.onWindowClick = this.onWindowClick.bind(this);
		this.onWindowKeydown = this.onWindowKeydown.bind(this);

		this.searchForm.addEventListener('submit', (evt) => {
			evt.preventDefault();
		});

		this._initSections();

		menuAim(document.querySelector('.menu-root'), {
			menuItemSelector: '.menu__list-item',
			menuItemSubMenuSelector: '.menu__section',
			menuItemActiveClassName: '_active',
			openCallback: (section) => {
				this.openSection(section);
			},
		});
	}
	open() {
		PageScroll.disabled();
		this.openers.forEach((opener) => opener.classList.add('_active'));
		this.container.classList.add('_active');
		HTML_CLASSLIST.add('_menu-opened');
		this.isOpened = true;
		this.activeTabbarLink = document.querySelector('.tabbar__link[aria-current="page"]');

		const searchInput = document.querySelector('.menu__search-form input');
		// searchInput?.focus();
		searchInput.value = '';
		searchInput.dispatchEvent(new Event('change'));

		if (this.activeTabbarLink) {
			this.activeTabbarLink.removeAttribute('aria-current');
		}

		window.addEventListener('click', this.onWindowClick);
		window.addEventListener('keydown', this.onWindowKeydown);
	}
	close() {
		this.openers.forEach((opener) => opener.classList.remove('_active'));
		this.container.classList.remove('_active');
		HTML_CLASSLIST.remove('_menu-opened');
		PageScroll.enabled();
		this.hideSearch();
		this.isOpened = false;

		if (this.activeTabbarLink) {
			this.activeTabbarLink.setAttribute('aria-current', 'page');
			this.activeTabbarLink = null;
		}

		window.removeEventListener('click', this.onWindowClick);
		window.removeEventListener('keydown', this.onWindowKeydown);
	}
	toggle() {
		this.isOpened ? this.close() : this.open();
	}
	_initSections() {
		this.sections = this.container.querySelectorAll('[data-menu-section]');
		this.activeSection = this.sections[0];

		const mm = window.matchMedia(MOBILE);

		this.sections.forEach((section) => {
			const name = section.getAttribute('data-menu-section');
			const opener = this.container.querySelector(`[data-menu-section-opener="${name}"]`);
			const closer = section.querySelector('[data-menu-section-closer]');
			const openerLvl = Number(opener.getAttribute('data-menu-level'));
			section.opener = opener;

			opener?.addEventListener('click', (evt) => {
				if (!mm.matches || (mm.matches && openerLvl === 0)) {
					return;
				}

				evt.preventDefault();
				this.openSection(section);
			});

			closer?.addEventListener('click', () => {
				this.closeSection();
			});
		});

		const onMMChange = () => {
			if (mm.matches) {
				this.closeSection();
			} else {
				if (!this.activeSection) {
					this.activeSection = this.sections[0];
				}
				this.openSection(this.activeSection);
			}
		};
		onMMChange();
		mm.addEventListener('change', onMMChange);
	}
	openSection(section) {
		if (!section) {
			return;
		}
		if (this.activeSection) {
			this.closeSection();
		}

		this.activeSection = section;
		this.activeSection.classList.add('_active');
		this.activeSection.opener.parentElement.classList.add('_active');
		this.activeSection.opener.classList.add('_active');
		this.container.classList.add('_submenu-opened');
	}
	closeSection() {
		if (!this.activeSection) {
			return;
		}

		this.container.classList.remove('_submenu-opened');
		this.activeSection.classList.remove('_active');
		this.activeSection.opener.parentElement.classList.remove('_active');
		this.activeSection.opener.classList.remove('_active');
		this.activeSection = null;
	}
	showLoader() {
		this.loader.classList.remove('_hidden');
		this.container.classList.add('_loading');
	}
	hideLoader() {
		this.loader.classList.add('_hidden');
		this.container.classList.remove('_loading');
	}
	initTabs() {
		const tabs = this.container.querySelector('[data-tabs]');

		if (tabs && tabs.tabsInstance) {
			tabs.tabsInstance.destroy();
			delete tabs.tabsInstance;
		}

		if (tabs) {
			tabs.tabsInstance = new Tabs(tabs);
		}
	}
	showSearch() {
		this.container.classList.add('_search-opened');
	}
	hideSearch() {
		this.container.classList.remove('_search-opened');
	}
	showEmpty() {
		this.empty.classList.remove('_hidden');
		this.container.classList.add('_empty');
	}
	hideEmpty() {
		this.empty.classList.add('_hidden');
		this.container.classList.remove('_empty');
	}
}

export default new Menu();
